import React from "react";
import styles from "./LoadingContainer.module.scss";

const LoadingContainer = ({ height, color = null }) => {
  const containerStyle = height
    ? { height: typeof height === "number" ? `${height}px` : height }
    : undefined;

  const loaderStyle = color
    ? {
        border: `2px solid ${color}`,
        borderBottomColor: "transparent",
      }
    : undefined;

  return (
    <div className={styles.loadingContainer} style={containerStyle}>
      <span className="loader" style={loaderStyle}></span>
    </div>
  );
};

export default LoadingContainer;
